import { atom } from 'recoil';
export const transactionTableState = atom({
    key: 'transactionTableState-checking-account-page',
    default: {
        isLoading: false,
        isTableLoading: false,
        filters: { input: '', deleted: false, selectedClassId: '0' },
        reloadTransactions: false,
        transactions: { data: [], count: 0, page: 0, pageCount: 0, total: 0 },
        dataNotFound: false
    }
});
export const transactionTableBrokerageState = atom({
    key: 'transactionTableState-brokerage-account-page',
    default: {
        isLoading: false,
        isTableLoading: false,
        filters: { input: '', deleted: false, selectedClassId: '0' },
        reloadTransactions: false,
        transactions: { data: [], count: 0, page: 0, pageCount: 0, total: 0 },
        dataNotFound: false
    }
});
export const transactionTableCCState = atom({
    key: 'transactionTableState-cc-account-page',
    default: {
        isLoading: false,
        isTableLoading: false,
        filters: { input: '', deleted: false, selectedClassId: '0' },
        reloadTransactions: false,
        transactions: { data: [], count: 0, page: 0, pageCount: 0, total: 0 },
        dataNotFound: false
    }
});
export const transactionTablePocketState = atom({
    key: 'transactionTableState-pockets-account-page',
    default: {
        isLoading: false,
        isTableLoading: false,
        filters: { input: '', deleted: false, selectedClassId: '0' },
        reloadTransactions: false,
        transactions: { data: [], count: 0, page: 0, pageCount: 0, total: 0 },
        dataNotFound: false
    }
});
